import { render, staticRenderFns } from "./AccountsTreePage.vue?vue&type=template&id=b1230306&scoped=true"
import script from "./AccountsTreePage.vue?vue&type=script&lang=js"
export * from "./AccountsTreePage.vue?vue&type=script&lang=js"
import style0 from "./AccountsTreePage.vue?vue&type=style&index=0&id=b1230306&prod&lang=scss&scoped=true"
import style1 from "./AccountsTreePage.vue?vue&type=style&index=1&id=b1230306&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1230306",
  null
  
)

export default component.exports